<template>
  <!-- Fondo semitransparente -->
  <transition name="fade">
    <div v-if="visible" class="fixed inset-0 bg-black/30   flex items-center justify-center z-50">

      <!-- Contenedor del modal -->
      <div
        class="  w-full max-w-8xl mx-2 px-4  py-2  rounded-2xl bg-gradient-to-r from-indigo-100 to-gray-100 text-black shadow-md">

        <div class="border-b pb-1 mb-6 flex justify-between items-start ">
          <!-- CONTENIDO CENTRADO -->
          <div class="flex-1 text-center space-y-0">
            <div class="grid grid-cols-1 gap-4 items-start text-center ">

              <!-- COL 2: SUBTÍTULO -->
              <div class="pt-0">

              </div>

            </div>
          </div>

          <!-- BOTÓN CERRAR -->
          <button @click="cerrar" class="text-gray-400 hover:text-gray-600 transition text-2xl leading-none ml-4"
            aria-label="Cerrar modal">
            ✕
          </button>
        </div>
        <div class="flex justify-between">
          <span
            class="text-xs text-indigo-500 font-mono bg-indigo-50 px-3 py-1 rounded-full shadow-sm">&#60;ModalSolicitudDet&#62;</span>
          <span class="text-sm text-indigo-500 font-mono bg-indigo-50 px-3 py-1 rounded-full shadow-sm font-bold">
            Presupuesto {{ $store.state.auth.userLogin.año_borrador }}</span>
          <span class="text-xs text-indigo-500 font-mono bg-indigo-50 px-3 py-1 rounded-full shadow-sm">{{ url_api
            }}</span>
        </div>
        <!-- Encabezado -->


        <!-- CONTENIDO -->

        <div v-if="showForm" class="space-y-2 text-gray-700">
          <p class="text-xs text-gray-500">
            <span v-if="error_props" class="text-red-500 text-xs flex items-center gap-1">
              ❌ error: falta presupuesto_id o mes
            </span>
          </p>
          <div class="flex justify-between gap-2">

            <div class="bg-gray-50 p-2   border border-gray-200 ">
              <div class="">


                <div class="grid grid-cols-5 gap-3 mt-5 font-mono text-sm items-center">

                  <!-- Año -->
                  <div class="text-gray-600">
                    Presupuesto {{ $store.state.auth.userLogin.año_borrador }}
                  </div>

                  <!-- Centro -->
                  <div class="text-gray-800 font-medium truncate">
                    {{ nomcentro }}
                  </div>

                  <!-- Cuenta -->
                  <div class="text-gray-800 font-medium truncate">
                    {{ nomcta }}
                  </div>

                  <!-- Descripción -->
                  <div>

                  </div>

              
                </div>

                <!-- GRILLA DE MESES -->
                <div class="grid grid-cols-12 gap-1 text-center mt-2">
                  <!-- nombre mes -->
                  <div v-for="(nombre, index) in meses" :key="index" @click="seleccionar_mes(index + 1)"
                    class="text-xs cursor-pointer font-mono px-2 py-1 text-xs transition shadow-sm" :class="{
                      'bg-yellow-200 text-black':
                        mesSelec === index + 1 && !error_saldo_insuficiente,
                      'bg-red-400 text-white':
                        mesSelec === index + 1 && error_saldo_insuficiente,
                      'bg-blue-100 text-blue-800 hover:bg-blue-200':
                        mesSelec !== index + 1,
                    }">
                    {{ nombre }}
                  </div>

                  <!-- presupuesto mes -->
                  <div v-for="mes in 12" :key="'fila2-' + mes" @click="seleccionar_mes(mes)"
                    class="px-2 py-1 cursor-pointer shadow-sm font-mono text-xs transition" :class="{
                      'bg-yellow-200 text-black':
                        mesSelec === mes && !error_saldo_insuficiente,
                      'bg-red-400 text-white':
                        mesSelec === mes && error_saldo_insuficiente,
                      'bg-green-100 hover:bg-green-200': mesSelec !== mes,
                    }">
                    <div v-if="loading"
                      class="w-4 h-4 border-4 border-gray-200 border-t-blue-600 rounded-full animate-spin mx-auto mb-1">
                    </div>

                    {{ marca_modificacion[mes] }}
                    {{ $formatoMiles(array_monto_mensual[mes]) }}
                  </div>

                  <!-- monto reasignaciones -->
                  <div v-for="mes in 12" :key="'fila3-' + mes" @click="seleccionar_mes(mes)"
                    class="  py-1 cursor-pointer shadow-sm font-medium text-xs transition" :class="{
                      'bg-yellow-200 text-black':
                        mesSelec === mes && !error_saldo_insuficiente,
                      'bg-red-400 text-white':
                        mesSelec === mes && error_saldo_insuficiente,
                      'bg-green-100 hover:bg-green-200': mesSelec !== mes,
                    }">
                    <input type="text" @blur="handleBlurMontoSolicitud(mes, $event)"
                      @focus="handleFocusMontoSolicitud($event)"
                      class="border px-2 py-1 text-xs w-full bg-white shadow-sm focus:ring-2 focus:ring-blue-300 outline-none" />
                  </div>
                </div>
                <!--
             <div class="mt-5 text-center text-gray-500 text-xs font-mono">
              Saldo por completar: ${{ $formatoMiles(saldo_por_completar) }}
            </div>
          -->
                <!-- BARRA PROGRESO
                <div class="w-full">
                  <div
                    class="w-full mt-3 bg-gray-300 rounded-full h-3 overflow-hidden"
                  >
                    <div class="h-4 transition-all duration-700 rounded-full"
                     :style="{
                        width: porcentaje_movimientos + '%',
                        background:
                          porcentaje_movimientos < 100
                            ? 'linear-gradient(90deg, #fb923c, #f97316)'
                            : 'linear-gradient(90deg, #22c55e, #16a34a)',
                      }"></div>
                  </div>

                  <div
                    class="flex justify-between text-xs text-gray-600 font-medium mt-1"
                  >
                    <span>0</span>
                    <span>${{ $formatoMiles(monto_solicitud) }}</span>
                  </div>
                </div>
-->
              </div>
            </div>
            <!-- Tabla de movimientos -->
            <div>
              <input type="text" id="descripcion_solicitud" v-model="descripcion_solicitud" placeholder="Descripción..."
                class="w-full px-3 py-1.5 text-sm border border-gray-300 rounded-lg 
             bg-white shadow-sm 
             focus:ring-2 focus:ring-blue-300 outline-none transition" />
              <div class=" w-[400px] border border-gray-200 bg-white p-0 shadow mx-auto">
                <div class="max-h-128 overflow-y-auto">

                  <table class="w-full text-xs text-gray-700 font-mono">
                    <thead class="sticky top-0 bg-gray-50">
                      <tr class="border-b text-gray-600">
                        <th class="text-center py-2 px-2">#</th>
                        <th class="text-center py-2 px-2">Mes</th>
                        <th class="text-center py-2 px-2">Monto</th>

                        <th class="py-2 px-2"></th>
                      </tr>
                    </thead>

                    <tbody>
                      <tr v-for="item in list_movimientos" :key="item.indice" class="border-b hover:bg-gray-50">
                        <td class="py-1 px-2">
                          {{ item.indice + 1 }}
                        </td>

                        <td class="py-1 px-2">
                          {{ this.meses[item.objMesMonto.mes - 1] }}
                        </td>
                        <td class="py-1 px-2">
                          
                         
                          <input 
                            type="text" 
                            class="text-sm"
                            :value="$formatoMiles(item.objMesMonto.monto)"
                             @input="actualizarMonto(item, $event)">

                        </td>

                        <td class="py-1 px-2 text-right">
                          <button @click="borrar_movimiento(item.indice)"
                            class="font-mono bg-red-500 hover:bg-gray-200 text-xs text-white px-3 py-1 text-xs transition">
                            Borrar
                          </button>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
                <div class="grid grid-cols-5 p-2 mt-0 w-full text-xs text-gray-700 bg-gray-50 font-mono">
                  <div></div>
                  <div>Total: </div>

                  <div class="text-right">
                    ${{ $formatoMiles(total_movimientos) }}


                  </div>
                </div>
                <p v-if="error_faltan_movimientos" class="text-red-500 text-xs mt-1 flex items-center gap-1">
                  ❌ Debe completar movimientos hasta sumar: ${{
                    $formatoMiles(monto_solicitud)
                  }}
                  pesos.
                </p>
              </div>
            </div>
          </div>

          <!-- ERRORES -->
          <p v-if="error_saldo_insuficiente" class="text-red-500 text-xs mt-1">
            ❌ Saldo del mes insuficiente
          </p>
          <p v-if="error_falta_selec_mes" class="text-red-500 text-xs mt-1">
            ❌ Debe seleccionar un mes
          </p>
          <p v-if="error_monto_solicitud_ya_alcanzado" class="text-red-500 text-xs mt-1">
            ❌ error: monto ingresado excesivo
          </p>



        </div>
        <div v-if="!showForm" class="space-y-2 text-gray-700 font-mono text-lg mt-5 mb-5">
          Solicitud de presupuesto grabada correctamente
          <br>
          <button @click="cerrar"
            class="mt-3 bg-gray-300 hover:bg-gray-200 text-gray-900 px-6 py-2 text-sm shadow-sm font-mono">
            Cerrar ventana
          </button>
        </div>
        <!-- FOOTER -->
        <div class="flex justify-end space-x-4 mt-2 pt-4 border-t text-xs text-gray-600">

          <button @click="cerrar"
            class="bg-gray-300 hover:bg-gray-200 text-gray-900 px-6 py-2 text-xs shadow-sm font-mono">
            Cerrar
          </button>


          <button v-if="showForm === true" @click="guardar" class="px-6 py-2 text-xs transition font-medium font-mono"
            :class="{
              'bg-gray-100 text-gray-300 cursor-not-allowed':
                enable_btn_grabar === false,
              'bg-violet-600 hover:bg-blue-700 text-white shadow-md':
                enable_btn_grabar === true,
            }">
            Guardar
          </button>

        </div>
      </div>
    </div>
  </transition>
</template>

<script>
import api from "@/api/axios";



export default {
  name: "ModalIngresoMes",
  emits: ["get_monto_mensual", "recarga_presupuestos_mensuales"],
  props: {
    visible: {
      type: Boolean,
      required: true,
    },

    nomcta: {
      type: String,
    },
    nomcentro: {
      type: String,
    },
    datosSolicitud: {
      type: Object,
    },

    timestamp: {
      type: String,
    },
    idSolicitudEdit: {
      type: Number
    }
  },
  computed: {
    mesTexto() {
      const meses = [
        "Enero",
        "Febrero",
        "Marzo",
        "Abril",
        "Mayo",
        "Junio",
        "Julio",
        "Agosto",
        "Septiembre",
        "Octubre",
        "Noviembre",
        "Diciembre",
      ];
      return this.mes > 0 ? meses[this.mes - 1] : "";
    },
  },

  methods: {
    handleFocusMontoSolicitud(event) {
      this.error_saldo_insuficiente = false;
      this.error_monto_solicitud_ya_alcanzado = false;
      event.target.value = "";
    },
    handleBlurMontoSolicitud(mes, event) {
      console.log("handleblur", mes, event.target.value);
      this.error_saldo_insuficiente = false;
      this.error_monto_solicitud_ya_alcanzado = false;
      this.error_faltan_movimientos = false;

      const monto = parseFloat(Number(
        String(event.target.value || 0).replace(/\./g, '')
      ));

      if (isNaN(monto)) {
        console.warn("Valor no es numérico");
        event.target.value = "";
        return false;
      }
      const objMesYMonto = { mes: mes, monto: monto };
      this.agregar_movimiento(objMesYMonto);
      event.target.value = "";
    },
    agregar_movimiento(objMesYMonto) {
      console.log('agregar movimiento')
      console.log(this.presupuesto_id, objMesYMonto)
      if (!this.presupuesto_id) {
        return false;
      }

      if (!objMesYMonto) {
        return false;
      } else {
        if ((typeof objMesYMonto === "object" && !("monto" in objMesYMonto))
          || (typeof objMesYMonto === "object" && !objMesYMonto.monto)
          || objMesYMonto.monto <= 0) {
          console.log('error!!')
          return false;
        }
      }

      console.log("tipo modificacion", this.tipo_modificacion);


      const tot_mes_tipeado = parseFloat(objMesYMonto.monto);
      let totmov = this.list_movimientos.reduce((total, item) => {
        return total + item.objMesMonto.monto;
      }, 0);

      // controlar que la suma de los movimientos, no supere monto de lo que quiero modificar
      console.log(
        "tot.movimientos realizados (en cualquier cta):",
        totmov,
        "cantidad comprometida para modificar el presup.",
        this.monto_solicitud
      );

      // 23-06-2026
      // total de modificaciones supera al monto solicitado
      //if (totmov + tot_mes_tipeado > this.monto_solicitud) {
      //  this.error_monto_solicitud_ya_alcanzado = true;
      //  return false;
      // }

      if (this.tipo_modificacion == 1) {
        console.log(
          tot_mes_tipeado,
          " - ",
          parseFloat(this.array_monto_mensual[objMesYMonto.mes])
        );

      }



      const presupuesto_inicial_mes = parseFloat(this.array_monto_mensual[objMesYMonto.mes]);

      console.log("restar lo sumado al presupuesto", tot_mes_tipeado); // si el presupuesto se quiere aumentar, debes quitarle a otros
      this.array_monto_mensual[objMesYMonto.mes] = presupuesto_inicial_mes + tot_mes_tipeado;
      objMesYMonto.operador = 1;

      objMesYMonto.presupuesto_mes_inicial = presupuesto_inicial_mes;

      let index = this.list_movimientos.length;
      this.list_movimientos.push({
        indice: index,
        centro_id: this.centro_id,
        cuenta_id: this.cuenta_id,
        objMesMonto: objMesYMonto,
        presupuesto_id_seleccionado: this.presupuesto_id,

      });

      console.log(
        "presupuesto mensual queda en:",
        this.array_monto_mensual[objMesYMonto.mes],

      );
      this.recalculaTotales()
      return true;
    },
    recalculaTotales(){
      
      const totmov = this.list_movimientos.reduce((total, item) => {
        return total + item.objMesMonto.monto;
      }, 0);

      this.total_movimientos = totmov;
      console.log("total_movimientos queda en:", this.total_movimientos);

      this.porcentaje_movimientos =
        (100 * this.total_movimientos) / this.monto_solicitud;
      this.saldo_por_completar = this.monto_solicitud - this.total_movimientos;


      this.list_movimientos = this.list_movimientos
        .sort((a, b) => a.objMesMonto.mes - b.objMesMonto.mes) // 🔹 ordenar por mes
        .map((item, i) => ({
          ...item,
          indice: i
        }))

    },
    borrar_movimiento(indice) {
      let movimiento_seleccionado = this.list_movimientos.filter(
        (item) => item.indice == indice
      );
      console.log('mov.selecc', movimiento_seleccionado[0])
      const indicemes = parseInt(movimiento_seleccionado[0].objMesMonto.mes);
      const monto_mes_tipeado = parseFloat(
        movimiento_seleccionado[0].objMesMonto.monto
      );



      this.array_monto_mensual[movimiento_seleccionado[0].objMesMonto.mes] =
        parseFloat(this.array_monto_mensual[indicemes]) - monto_mes_tipeado;

      console.log('list 1', this.list_movimientos)

      // recrear la lista, dejando de lado el eliminado
      //let list_movimientos_nuevo = this.list_movimientos.filter(
      //  (item) => item.indice !== indice
      //);

      let list_movimientos_nuevo = this.list_movimientos
        .filter(item => item.indice !== indice)
        .sort((a, b) => a.objMesMonto.mes - b.objMesMonto.mes) // 🔹 ordenar por mes
        .map((item, i) => ({
          ...item,
          indice: i
        }))




      console.log('list 2', list_movimientos_nuevo)

      this.total_movimientos = list_movimientos_nuevo.reduce((total, item) => {
        return total + item.objMesMonto.monto;
      }, 0);
      console.log("total movimientos", this.total_movimientos);

      this.list_movimientos = list_movimientos_nuevo;
      this.porcentaje_movimientos =
        (100 * this.total_movimientos) / this.monto_solicitud;
      this.saldo_por_completar = this.monto_solicitud - this.total_movimientos;

      return true;
    },
     actualizarMonto(item, event) {
      // Remover puntos y espacios, convertir a número
      const valorLimpio = event.target.value.replace(/\./g, '').replace(/\s/g, '')
      const numero = parseFloat(valorLimpio) || 0
      item.objMesMonto.monto = numero
      this.recalculaTotales()
    },
    recargaDatos(datProp) {
      console.log('recarga datos')
      /** datProp es datosSolicitud
       * this.datosSolicitud = {
              "presupuesto_id": resp.data?.presupuesto_id,
              "cuenta_total_presupuesto_aa_abierto":this.cuenta_total_presupuesto_aa_abierto,
              "cuenta_total_presupuesto_aa_borrador":resp.data?.total_presupuesto,
              "descripcion_solicitud": obj.descripcion_solicitud,
              "monto_solicitud": obj.monto_solicitud,
              "centro_id": this.centro_id,
              "cuenta_id": this.cuenta_id,
              "accion_id":1,
              "ingresos": resp.data?.ingresos[]
              
            }
       */
      console.log("recarga", datProp);
      this.reasignar_isOn = false;
      this.enable_btn_grabar = true;
      this.array_monto_mensual.fill(0);
      this.monto_solicitud = "";
      this.puede_restar = false;
      this.puede_sumar = false;
      this.error_monto = false;
      this.saldo_por_completar = 0;
      this.total_movimientos = 0;
      this.porcentaje_movimientos = 0;



      if (datProp && typeof datProp === "object") {
        //this.monto_presupuesto_mes = datProp.presupuesto_mensual
        //  ? parseFloat(datProp.presupuesto_mensual)
        //  : 0;
        this.descripcion_solicitud = datProp.descripcion_solicitud;
        this.mes = datProp.mes;
        this.presupuesto_id = datProp.presupuesto_id;

        this.cuenta_total_presupuesto_aa_abierto = datProp.cuenta_total_presupuesto_aa_abierto;
        this.cuenta_total_presupuesto_aa_borrador = datProp.cuenta_total_presupuesto_aa_borrador;
        this.ingreso_id = datProp.id;
        this.centro_id = datProp.centro_id;
        this.cuenta_id = datProp.cuenta_id;

        this.tipo_modificacion = parseInt(datProp.accion_id);
        this.monto_solicitud = datProp?.monto_solicitud || 0;
        this.reasignar_isOn = datProp.reasignar == "true" ? true : false;
        switch (this.tipo_modificacion) {
          case 1:
            this.glosa_accion = "Aumentar Presupuesto";
            this.glosa_operacion = "Sumar";
            break;
          case 2:
            this.glosa_accion = "Disminuir Presupuesto";
            this.glosa_operacion = "Restar";
            break;
        }
      }

      if (
        this.presupuesto_id == 0 ||
        this.presupuesto_id == "" ||
        this.mes == 0 ||
        this.mes == ""
      ) {
        this.error_props = true;
      }

      this.saldo_por_completar = this.monto_solicitud - this.total_movimientos;
      this.centroSelec = 0;
      this.cuentaSelec = 0;



      this.presupuesto_tentativo = this.monto_presupuesto_mes + this.monto_solicitud;

      this.uploading = false;
      this.uploadProgress = 0;
      this.uploadProgressGlosa = ''

      /*
       "datProp.ingresos": [
        {
            "id": 507021,
            "mes": 1,
            "monto_mensual": "5001.00",
            "glosa": "duplicacion de presupuesto automatico",
            "timestamp": "2026-04-25T18:43:51.629281-04:00",
            "presupuesto_id": 64250
        },
      */
      // [ { "indice": 0, 
      //    "centro_id": 8, "cuenta_id": 59,
      //  "objMesMonto":
      //  { "mes": 2, "monto": 1, "operador": 1, "presupuesto_mes_inicial": 0 }, "presupuesto_id_seleccionado": 64250 } 

      if (datProp && Array.isArray(datProp.ingresos)) {

        const mapa = Object.fromEntries(
          datProp.ingresos.map((item) => [item.mes, item.monto_mensual])
        );

        for (let mes = 1; mes <= 12; mes++) {
          // || usa 0 si el resultado no es válido.
          const valor_from_api = Number(mapa[mes]) || 0;
          this.array_monto_mensual[mes] = valor_from_api;
          console.log("monto ingreso", mes, this.array_monto_mensual[mes]);
        }




        // fin itera

      }

    },
    cerrar() {
      this.resetea_form();
      this.$emit("update:visible", false);
    },

    async guardar() {

      const presupuesto_id = this.presupuesto_id;
      if (!presupuesto_id) {
        console.log("error general falta presupuesto_id ");
        this.error_props = true;
        return false;
      }

      //const monto_solicitud   = parseFloat(this.monto_solicitud);
      const total_movimientos = parseFloat(this.total_movimientos);
      console.log('total movimientos', total_movimientos)
      // 23-06-2026
      //if (monto_solicitud == 0 || isNaN(monto_solicitud)) {
      // this.error_monto = true;
      //  return false;
      //}

      // 23-06-2026
      //if (total_movimientos !== monto_solicitud) {
      //    this.error_faltan_movimientos = true;
      //    return false;
      //}

      try {

        const data = {
          presupuesto_id: presupuesto_id,
          monto_solicitud: this.total_movimientos,
          descripcion_solicitud: this.descripcion_solicitud,
          movimientos: this.list_movimientos,
          solicitud_id: this.idSolicitudEdit,
        }

        const url = this.url_api;
        const resp = await api.post(url, data, {
          headers: {
            "Content-Type": "application/json",

          },
        });

        const status = resp.data.status;
        switch (status) {
          case 201:
            console.log("datos enviados ok");
            // remover formulario y mostrar mensaje
            this.showForm = false;
            // volver a llamar api
            this.$emit("recarga_solicitudes");
            this.modificacion_id = resp.data.modificacion_id;
            break;
        }
      } catch (err) {
        console.log(err);
      }
    },
    seleccionar_mes(mes) {
      this.error_falta_selec_mes = false;
      this.error_selecciona_cuenta = false;
      this.error_monto = false;
      this.mesSelec = 0;
      const tipo_modificacion = parseInt(this.tipo_modificacion);
      const monto_solicitud = parseFloat(this.monto_solicitud);
      const monto_mes_seleccionado = parseFloat(this.array_monto_mensual[mes]);
      const total_ingresos = parseFloat(this.monto_presupuesto_mes);

      if (!this.centroSelec || this.centroSelec <= 0) {
        this.error_centro = true;
        return false;
      }

      if (!this.cuentaSelec || this.cuentaSelec <= 0) {
        this.error_cuenta = true;
        return false;
      }

      if (tipo_modificacion == 1) {
        if (monto_solicitud <= 0) {
          console.log("falta ingresar monto", this.monto_solicitud);
          this.error_monto = true;
          return false;
        } else {
          // if (monto_solicitud > monto_mes_seleccionado) {
          //   console.log('saldo insuficiente', monto_mes_seleccionado,monto_solicitud )
          //   this.error_saldo_insuficiente = true;
          //   }
        }
      }

      if (tipo_modificacion == 2 && total_ingresos < monto_mes_seleccionado) {
        console.log(
          "monto sobrepasado",
          total_ingresos,
          monto_mes_seleccionado
        );
        //  this.mesSelec = 0;
        // this.error_saldo_insuficiente = true
        // return false;
      }

      this.mesSelec = mes;
    },
    handleBlurMonto() {
      /* this.error_monto = false;
       const monto_solicitud = parseFloat(this.monto_solicitud)
       const monto_presupuesto_mes = parseFloat(this.monto_presupuesto_mes);
       const tipo_modificacion = this.tipo_modificacion;
       if (tipo_modificacion == 1) {
         if (!monto_solicitud || monto_solicitud == 0) {
           console.log('ingrese monto modificacion')
           this.error_monto = true;
           return false;
         }
         if (this.mesSelec && this.mesSelec > 0 && monto_solicitud <= this.array_monto_mensual[this.mesSelec]) {
           this.error_saldo_insuficiente = false;
         }
       } else {
         console.log('blur', monto_presupuesto_mes, monto_solicitud)
         this.error_ingresos_insuficientes = false;
         if (monto_presupuesto_mes < monto_solicitud) {
           console.log('error')
           this.error_ingresos_insuficientes = true;
           return false;
         }
       }
     */
    },

    async onFileChange(event) {
      console.log("Archivo seleccionado:", event.target.files[0]);

      const formData = new FormData();
      formData.append("file", event.target.files[0]);
      formData.append("presupuesto_id", this.presupuesto_id);
      formData.append("mes", this.mes);

      this.uploadProgress = 0;
      this.uploadProgressGlosa = 'Subiendo archivo...';
      this.uploading = true;
      try {
        const resp = await api.post(
          "/api/v1/upload/modificaciones/",
          formData,
          {
            headers: {
              "Content-Type": "multipart/form-data",
            },
            onUploadProgress: (progressEvent) => {
              if (progressEvent.total) {
                this.uploadProgress = Math.round(
                  (progressEvent.loaded * 100) / progressEvent.total
                );

              }
            },
          }
        );
        this.error_file = false;
        if (resp.data.error) {
          alert(resp.data.error);
          this.error_file = true;
          this.uploadProgressGlosa = '';
          this.uploadProgress = 0;
          return;
        }


        this.file_url = resp.data.file_url;
        this.uploadProgressGlosa = resp.data.message;
        this.fileKey++;

      } catch (error) {
        console.error("Error al enviar:", error);
        this.uploadProgressGlosa = "Error al subir archivo";
      }
    },

    async getSolicitudes() {

      let indice = 0
      this.total_movimientos = 0
      this.list_movimientos = []


      try {



        const response = await api.post('/api/v1/solicitud/', {
          solicitud_id: this.idSolicitudEdit
        })

        // 🔹 guardar respuesta
        const solicitud = response.data
        const detalles = response.data.detalles
        this.descripcion_solicitud = solicitud.descripcion;
        this.monto_solicitud = solicitud.total;

        /**
         * [ { "indice": 0, "centro_id": 8, "cuenta_id": 59,
         *  "objMesMonto": { "mes": 2, "monto": 1000, "operador": 1, "presupuesto_mes_inicial": 0 },
         *  "presupuesto_id_seleccionado": 64250 } ]
         */
        detalles.map(det => {
          this.total_movimientos += det.monto
          this.list_movimientos.push({
            indice: indice,
            centro_id: this.centro_id,
            cuenta_id: this.cuenta_id,
            objMesMonto: {
              mes: det.mes,
              monto: det.monto,
              operador: 1
            },
            presupuesto_id_seleccionado: this.presupuesto_id

          })
          indice++;
        })

        console.log('list movimientos', this.list_movimientos)
        //23-06-2026 this.porcentaje_movimientos =  (100 * this.total_movimientos) / this.monto_solicitud;
        //23-06-2026 this.saldo_por_completar = this.monto_solicitud - this.total_movimientos;
        return true

      } catch (err) {
        console.log(err)

        // opcional: manejar error backend
        if (err.response) {
          console.log(err.response.data)
        }

        return null
      }
    },
    resetea_form() {
      this.error_file = false;
      this.error_monto = false;
      this.error_centro = false;
      this.error_cuenta = false;
      this.error_sinsaldo_mensual = false;
      this.error_saldo_insuficiente = false;
      this.error_ingresos_insuficientes = false;
      this.error_falta_selec_mes = false;
      this.error_faltan_movimientos = false;
      this.mesSelec = 0;
      this.file_url = "";
      this.monto_mensual = "";
      this.centroSelec = 0;

      this.cuentaSelec = 0;
      this.fileKey++;
      this.file_url = "";
      this.glosa = "";
      this.enable_btn_grabar = true;
      this.reasignar_isOn = true;
      this.puede_mostrar_meses = false;
      this.list_movimientos = [];

      this.glosa_accion = "";
      this.glosa_reasignacion = "";
      this.saldo_por_completar = 0;


      this.showForm = true;
    },
    async pdf() {

      const url = this.VUE_APP_DJANGO_API_URL + "/api/v1/descargapdf/" + this.modificacion_id;
      window.open(url)
    }
  },
  data() {
    return {
      url_api: '',
      url_add: 'api/v1/solicitud/add/',
      url_upd: 'api/v1/solicitud/upd/',
      descripcion_solicitud: '',
      loading: false,
      tipo_modificacion: 1,
      centro_id: 0,
      cuenta_id: 0,
      monto_solicitud: 0,
      monto_presupuesto_mes: 0,
      glosa: "",
      presupuesto_id: 0,
      ingreso_id: 0,
      accion_id: 0,
      mes: 0,
      file_url: "",
      cuentas: [],
      centros: [],
      meses: [
        "Ene.",
        "Feb.",
        "Mar.",
        "Abr.",
        "May.",
        "Jun.",
        "Jul.",
        "Ago.",
        "Sept.",
        "Oct.",
        "Nov.",
        "Dic.",
      ],
      monto_mensual: "",
      array_monto_mensual: new Array(13).fill(0),
      marca_modificacion: new Array(13),
      cuentaSelec: 0,
      centroSelec: 0,

      objMesYMonto: {},
      mesSelec: 0,

      reasignar_isOn: false,
      accion: "Disminución",
      error_props: false,
      error_monto: false,
      error_file: false,
      error_cuenta: false,
      error_centro: false,
      error_selecciona_cuenta: false,
      error_saldo_insuficiente: false,
      error_falta_selec_mes: false,
      error_ingresos_insuficientes: false,
      error_monto_solicitud_ya_alcanzado: false,
      error_faltan_movimientos: false,
      fileKey: 0,
      enable_btn_grabar: true,
      puede_restar: false,
      puede_sumar: false,
      puede_mostrar_meses: false,
      porcentaje_movimientos: 0,
      list_total_movimientos: [],
      list_movimientos: [],
      glosa_accion: "",
      glosa_reasignacion: "",
      glosa_operacion: "",
      presupuesto_tentativo: 0,
      total_movimientos: 0,
      saldo_por_completar: 0,
      presupuesto_id_Selec: "",
      showForm: true,
      modificacion_id: 0,
      spanresp: '',
      uploadProgress: 0,
      uploading: false,
      uploadProgressGlosa: '',
      cuenta_total_presupuesto_aa_abierto: 0,
      cuenta_total_presupuesto_aa_borrador: 0,
      VUE_APP_DJANGO_API_URL: ''
    };
    /**
     * list_movimientos
     * 
     [{
        "indice":0,
        "centro":37,
        "centro_datos":"VCO069000000000 - Amigos del Parque Pumalin",
        "cuenta":32,
        "cuenta_datos":"4.5.1030.40.15 - Alimentación animales de trabajo",
        "objMesMonto":{
          "mes":5,
          "monto":4
        }
     }]
     */
  },
  mounted() {
    this.VUE_APP_DJANGO_API_URL = process.env.VUE_APP_DJANGO_API_URL
    this.enable_btn_grabar = true;
    this.centroSelec = this.centro_id;

    this.monto_mensual = "";
    this.array_monto_mensual.fill(0);
    this.marca_modificacion.fill("");
    this.file_url = "";

    this.resetea_form();
  },
  watch: {


    timestamp: function () {
      console.log('watch timestamp')


    },
    visible: function (v) {

      if (v) {
        console.log('visible')
        if (this.idSolicitudEdit) {
          this.url_api = this.url_upd;
          this.getSolicitudes();
        } else {
          this.url_api = this.url_add
        }
      }
      this.recargaDatos(this.datosSolicitud);
    }
  }
};
</script>

<style scoped></style>
